import axios from "axios";
import store from '@/store';


const apiClient = axios.create({
  baseURL: `${process.env.VUE_APP_DOTNET_API_URL}`
});

const apiClientDirectus = axios.create({
  baseURL: `${process.env.VUE_APP_DIRECTUS_API_URL}`
});

const apiClienteBuy = axios.create({
  baseURL: `${process.env.VUE_APP_EBUY_API_URL}`
});

apiClient.interceptors.request.use(
  function(config) {
    // 在发送请求之前做些什么
    config.headers["X-Shop-ID"] = store.state.shopID;
    return config;
  },
  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

export default apiClient;


/*
export async function fetchProductCatApi() {
  try {
    const response = await apiClient.get(`/api/goodstype`);
    return response.data;
  } catch (error) {
    console.error("List Category API 请求失败:", error);
    throw error;
  }
}
*/

export async function addMember(name, phone, address, email, country, countryCode, totalPrice) {
  const memberDirectusToken = process.env.VUE_APP_DIRECTUS_WEB_ADD_MEMBER_TOKEN;

  try {
    // 1. 檢查 member 是否存在
    const response = await apiClientDirectus.get(
      `items/ShopMember?fields=phone,id,totalSpending&filter[shopID][_eq]=${store.state.shopID}&filter[phone][_eq]=${phone}`,
      {
        headers: {
          Authorization: `Bearer ${memberDirectusToken}`
        }
      }
    );

    if (response.data.data.length > 0) {
      const existingMember = response.data.data[0];
      const existingId = existingMember.id;
      const currentSpending = parseFloat(existingMember.totalSpending) || 0;
      const updatedSpending = currentSpending + parseFloat(totalPrice);

      try {
        await apiClientDirectus.patch(
          `items/ShopMember/${existingId}`,
          {
            address: address,
            email: email,
            country: country,
            countryCode: countryCode,
            totalSpending: updatedSpending
          },
          {
            headers: {
              Authorization: `Bearer ${memberDirectusToken}`
            }
          }
        );
        console.log("Member totalSpending updated.");
      } catch (error) {
        console.error("更新會員總消費額失敗:", error);
        throw error;
      }

      return; // 已處理，不新增
    }

    // 2. 如果不存在，新增 member
    const newMemberData = {
      shopID: store.state.shopID,
      name: name,
      phone: phone,
      address: address,
      email: email,
      country: country,
      countryCode: countryCode,
      totalSpending: isNaN(parseFloat(totalPrice)) ? 0 : parseFloat(totalPrice),
    };

    const addResponse = await apiClientDirectus.post(
      `items/ShopMember`,
      newMemberData,
      {
        headers: {
          Authorization: `Bearer ${memberDirectusToken}`,
        },
      }
    );

    console.log("New member added:", addResponse.data);
    return addResponse.data;

  } catch (error) {
    console.error("Add Member Directus API 請求失敗:", error.response.data);
    throw error;
  }
}

export async function CSSApi() {
  try {
    const response = await apiClientDirectus.get(
    `items/CSS?fields=*,*&filter[shopID][_eq]=${store.state.shopID}`);
    console.log("CSS:\n" + JSON.stringify(response, null, 2));
    return response.data;
  } catch (error) {
    console.error("Display Product Detail API 请求失败:", error);
    throw error;
  }
}

export async function ShopInfoApi() {
  try {
    const response = await apiClientDirectus.get(
    `items/ShopInfo?fields=*,*&filter[shopID][_eq]=${store.state.shopID}`);
    console.log("Shop Setting:\n" + JSON.stringify(response, null, 2));
    return response.data.data[0];
  } catch (error) {
    console.error("Display Product Detail API 请求失败:", error);
    throw error;
  }
}

export async function PaymentSettingApi() {
  try {
    const response = await apiClientDirectus.get(
    `items/PaymentSetting?fields=*,*&filter[shopID][_eq]=${store.state.shopID}`);
    console.log("Shop Setting:\n" + JSON.stringify(response, null, 2));
    return response.data.data[0];
  } catch (error) {
    console.error("Display Product Detail API 请求失败:", error);
    throw error;
  }
}

export async function DeliverySettingApi() {
  try {
    const response = await apiClientDirectus.get(
    `items/DeliverySetting?fields=*,*&filter[shopID][_eq]=${store.state.shopID}`);
    console.log("Shop Setting:\n" + JSON.stringify(response, null, 2));
    return response.data.data[0];
  } catch (error) {
    console.error("Display Product Detail API 请求失败:", error);
    throw error;
  }
}

export async function ShopOtherSettingApi() {
  try {
    const response = await apiClientDirectus.get(
    `items/ShopOtherSetting?fields=*,*&filter[shopID][_eq]=${store.state.shopID}`);
    console.log("Shop Setting:\n" + JSON.stringify(response, null, 2));
    return response.data.data[0];
  } catch (error) {
    console.error("Display Product Detail API 请求失败:", error);
    throw error;
  }
}


export async function fetchProductCatApi() {
  try {
    const response = await apiClientDirectus.get(`/items/GoodsMultType?filter[shopID][_eq]=${store.state.shopID}&sort=typeName`);
    return response.data.data;
  } catch (error) {
    console.error("List Category API 请求失败:", error);
    throw error;
  }
}

/*
export async function fetchProductListApi(typeName) {
  try {
    const response = await apiClient.get(
      `/api/goodsbytypename/${typeName}`);
    return response.data;
  } catch (error) {
    console.error("List Production API 请求失败:", error);
    throw error;
  }
}
*/

export async function fetchProductListApi(typeName) {
    try {
      console.log("typeName: " + typeName);

      //let url = `items/Goods?fields=*,cmsImages.directus_files_id.filename_disk,cmsImages.directus_files_id.title,multTypeID.GoodsMultType_id.typeName,multTypeID.GoodsMultType_id.typeNameEN,multTypeID.GoodsMultType_id.typeURL,multTypeID.GoodsMultType_id.typeOrdering,multTagID.GoodsMultTag_id.tagName,multTagID.GoodsMultTag_id.tagNameEN&filter[shopID][_eq]=${store.state.shopID}&sort=-onTopProduct,-multTypeID.GoodsMultType_id.typeOrdering,price`;
      let url = `items/Goods?fields=*,cmsImages.directus_files_id.filename_disk,cmsImages.directus_files_id.title,multTypeID.GoodsMultType_id.typeName,multTypeID.GoodsMultType_id.typeNameEN,multTypeID.GoodsMultType_id.typeURL,multTypeID.GoodsMultType_id.typeOrdering,multTagID.GoodsMultTag_id.tagName,multTagID.GoodsMultTag_id.tagNameEN&filter[shopID][_eq]=${store.state.shopID}&sort=-onTopProduct,-multTypeID.GoodsMultType_id.typeOrdering,pName,pNameEN,-price`;

      if (typeName == "0") {
        url += `&filter[hotProduct][_eq]=1&filter[pOnline][_eq]=1`;
      }

      if (typeName !== "0") {
        url += `&filter[multTypeID][GoodsMultType_id][typeURL][_eq]=${typeName}&filter[pOnline][_eq]=1`;
      }

      const response = await apiClientDirectus.get(url);
      console.log("API Product List:\n" + JSON.stringify(response, null, 2));
      return response.data.data;

    } catch (error) {
      console.error("List Production API 请求失败:", error);
      throw error;
    }
}

/*

export async function fetchProductDetailApi(pURL) {
  try {
    const response = await apiClient.get(`/api/goods/${pURL}`);
    //console.log("API URL" + `${apiDomain}/api/goods/${pName}`);
    return response.data;
  } catch (error) {
    console.error("Display Product Detail API 请求失败:", error);
    throw error;
  }
}

*/

export async function fetchProductDetailApi(pURL) {
  try {
    const response = await apiClientDirectus.get(
    `items/Goods?fields=*,cmsImages.directus_files_id.filename_disk,cmsImages.directus_files_id.title,multTypeID.GoodsMultType_id.typeName,multTagID.GoodsMultTag_id.tagName,multTagID.GoodsMultTag_id.tagNameEN&filter[shopID][_eq]=${store.state.shopID}&filter[pURL][_eq]=${pURL}&filter[pOnline][_eq]=1`);
    return response.data.data;
  } catch (error) {
    console.error("Display Product Detail API 请求失败:", error);
    throw error;
  }
}


export async function fetchOrderApi() {
  try {
    const orderInfoString = localStorage.getItem("myData");
    const orderInfo = JSON.parse(orderInfoString);
    console.log("All order information:\n" + JSON.stringify(orderInfo, null, 2));

    const response = await apiClient.post(`/api/order`, orderInfo);

    return response.data.data;
    
  } catch (error) {
    console.error("Save Order API 请求失败:", error.response.data);
    throw error; // 捕獲錯誤並重新拋出
  }
}

export async function paySuccessFPSApi() {
  try {
    const orderInfoString = localStorage.getItem("myData");
    const orderInfo = JSON.parse(orderInfoString);

    const orderID = orderInfo.orderInfo.orderID;
    const paymentScreenCap = orderInfo.orderInfo.paymentScreenCap;

    const payload = {
        orderID: orderID,
        paymentScreenCap: paymentScreenCap
    };

    console.log("All order information in paySuccessFPSApi:\n" + JSON.stringify(payload, null, 2));

    const response = await apiClient.put(`/api/paySuccessFPS`, payload);

    return response.data.data;
    
  } catch (error) {
    console.error("paySuccessFPSApi VUE-API 请求失败:", error.response.data);
    throw error; // 捕獲錯誤並重新拋出
  }
}
// CHECK ORDER PAY-SUCCESS STATUS

export async function checkOrderID(orderID) {
  try {
    const response = await apiClient.get(`api/OrderSuccess/${orderID}`);

    console.log("successPay in VUE API: " + response.data.successPay);
    return response;
    
  } catch (error) {
    console.error("Check orderID API error: ", error.response.data);
    throw error; // 捕獲錯誤並重新拋出
  }
}

// SEND Telegram Message to back office


export async function sendTelegram(orderID) {
  try {
    const response = await apiClient.get(`api/sendTelegram/${orderID}`);

    console.log("Success send Telegram: " + response.data.successPay);
    return response;
    
  } catch (error) {
    console.error("Send Telegram VUE-API error:", error.response.data);
    throw error; // 捕獲錯誤並重新拋出
  }
}


export async function RobotApi() {
  try {
    const orderInfoString = localStorage.getItem("myData");
    const orderInfo = JSON.parse(orderInfoString);
    console.log("All order information to Robot:\n" + JSON.stringify(orderInfo, null, 2));

    const response = await apiClient.post(`/api/robot`, orderInfo);

    return response.data.data;
    
  } catch (error) {
    console.error("RobotApi 请求失败:", error);
    throw error; // 捕獲錯誤並重新拋出
  }
}

/*

export async function listContentPagesApi(area) {
  try {
    console.log("List Content Page in VUE API by Area " + area);
    const response = await apiClient.get(`/api/listContentPages/${area}`);
    return response.data;
  } catch (error) {
    console.error("Fetch List Content API request failed:", error);
    throw error;
  }
}
*/

export async function listContentPagesApi(area) {
  try {
    console.log("List Content Page in VUE API by Area " + area);
    const response = await apiClientDirectus.get(`items/ContentPages?fields=*&filter[pageArea][_contains]=${area}&filter[shopID][_eq]=${store.state.shopID}&sort[]=-pageOrder`);
    return response.data.data;
  } catch (error) {
    console.error("Fetch List Content API request failed:", error);
    throw error;
  }
}


export async function GetContentPagesApi(pageID) {
  try {
    console.log("Get Content Page Detail in VUE API by pageID: "+ pageID);
 
    const response = await apiClient.get(`/api/getContentPages/${pageID}`);
    return response.data;
  } catch (error) {
    console.error("Fetch detail content page API request failed:", error);
    throw error;
  }
}

// PROMOTION AND EVENT API **************************** //


export async function NewSignUpApi(newPagesData) {
  try {
    console.log("Create Page Data: " + JSON.stringify(newPagesData));
    const response = await apiClient.post(`/api/EventSignUp`, newPagesData);
    return response.data;
  } catch (error) {
    const msg = error.response?.data || error.message;
    console.error(msg);
    // 這裡要顯示就顯示，要傳回呼叫端就傳
    throw new Error(msg);
  }
}

export async function GetPromotionEventPageApi(eventURL) {
  try {
    console.log("Get Promotion Event Page Detail in VUE API by eventURL: "+ eventURL);
 
    const response = await apiClientDirectus.get(`items/PromotionEvent?fields=*,cmsImages.*&filter[shopID][_eq]=${store.state.shopID}&filter[eventURL][_eq]=${eventURL}`);

    return response.data.data[0];
  } catch (error) {
    console.error("Fetch detail Promotion Event page API request failed:", error);
    throw error;
  }
}

// eBUY API **************************** //

export async function eBuySitesApi() {
  try {
    const eBuyResponse = await apiClienteBuy.get(
      `/v2/sites`);
    return eBuyResponse.data;
  } catch (error) {
    console.error("List eBuy API 请求失败:", error);
    throw error;
  }
}

//************************************ */
// UPLOAD FILE
//************************************ */

export async function uploadPhoto(file) {
  const newFileName = file.name.replace(/\s+/g, "_");

  // 创建一个新的 File 对象
  const newFile = new File([file], newFileName, { type: file.type });

  const formData = new FormData();
  formData.append("file", newFile);

  try {
    const response = await apiClient.post(`/api/upload`, formData);
    console.log("photo new file name in VUE API Page: " + response.data.newFileName);
    return response.data.newFileName;
  } catch (error) {
    console.error("File upload error:", error);
  }
}

export async function delPhoto(file) {
  try {
    console.log("Del file name in VUE API Page: " + file);
    const response = await apiClient.delete(`/api/upload/${file}`);
    return response.data;
  } catch (error) {
    console.error("File del error:", error);
  }
}

//************************************ */
// UPLOAD FILE (DIRECTUS)
//************************************ */

export async function uploadPhotoDirectus(file) {
  const memberDirectusToken = process.env.VUE_APP_DIRECTUS_WEB_ADD_MEMBER_TOKEN;
  const newFileName = file.name.replace(/\s+/g, "_");

  // 创建一个新的 File 对象
  const newFile = new File([file], newFileName, { type: file.type });

  const formData = new FormData();
  formData.append("file", newFile);
  formData.append("shopID", "SHOP-12345");

  try {
    const response = await apiClientDirectus.post(`files`, formData);
    console.log(
      "Directus upload photo new file name in VUE API Page: " +
      JSON.stringify(response.data.data, null, 2)
    );

    const fileId = response.data.data.id;

    // 2. 更新 shopID
    const patchResponse = await apiClientDirectus.patch(
      `files/${fileId}`,
      { shopID: store.state.shopID },
      {
        headers: {
          Authorization: `Bearer ${memberDirectusToken}`
        }
      }
    );

    console.log("Updated file with shopID:", JSON.stringify(patchResponse.data.data, null, 2));
    return patchResponse.data.data.filename_disk;

  } catch (error) {
      console.error('File upload error:', error.response?.data || error.message);
  }
}